@if (customFiltersTableService.activateFilters) {
  <div class="ark-filter-component">
    <div class="row p-0 ml-2 mb-0">
      <h4 class="ark-h4 mt-3">{{'general.Filters' | translate}}</h4>
    </div>
    <div class="ark-filter-summary-container pt-0 mt-0">
      <div class="ark-filters-container">
        <div class="ark-input-filters-container">
          @for (filter of customFiltersTable; track filter.FilterType) {
            <div class="ark-input-filter" [ngStyle]="{'order': filter.Order}">
              <app-selector-chips [title]="filter.Title | translate" [optionsList]="filter.FiltersList"
                [selectorOptions]="filter.SelectorOptions"
                (changedOptions)="selectedCustomFilter.emit({FilterType: filter.FilterType, Filter: $event })">
              </app-selector-chips>
            </div>
          }
        </div>
      </div>
      <div class="ark-filter-action-container">
        <div class="row justify-content-end align-items-center m-0">
          <div class="col col-auto p-0">
            <a mat-raised-button class="btn ark-btn" color="primary" (click)="clearFilter()">
              <span>{{'general.CleanFilter' | translate}}</span>
            </a>
          </div>
          <div class="col col-auto p-0">
            <a class="btn ark-btn-action close" (click)="hideFilters()">
              <span><i class="fal fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
}
